import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useProducts = () =>
  useQuery({ queryKey: ["products"], queryFn: async () => (await api.get("/products")).data });

export const useProduct = (slug) =>
  useQuery({ queryKey: ["product", slug], queryFn: async () => (await api.get(`/products/${slug}`)).data, retry: false });
